// src/pages/Dashboard/index.js
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
} from "reactstrap";

// Pages Components
import Miniwidget from "./Miniwidget";
import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";
import Inbox from "./inbox";
import RecentActivity from "./recent-activity";
import WidgetUser from "./widget-user";
import YearlySales from "./yearly-sales";
import LatestTransactions from "./latest-transactions";
import LatestOrders from "./latest-orders";
import PowerBIDashboard from "./PowerBIDashboard"; // <-- Import the new component

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { updateToken } from "helpers/api_helper";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { fetchAdminDashboardData, fetchContentManagerDashboardData, fetchTrainerDashboardData } from "helpers/dashboard_helper";
import Loader from "components/Loader/Loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Dashboard = (props) => {
  document.title = "Dashboard | LMS Admin Dashboard";

  const breadcrumbItems = [
    { title: "LMS", link: "#" },
    { title: "Dashboard", link: "#" }
  ];
  const query = useQuery();

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems);
  }, [props]); // Add props to the dependency array

  const [organizationId, setOrganizationId] = useState(null); // Initialize with null
  const [dashboardData, setDashboardData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let a = JSON.parse(localStorage.getItem("authUser"));
    if (a) {
      setOrganizationId(a.organizationId);
      setUser(a);
    }
  }, []);

  useEffect(() => {
    if (organizationId !== null) {
      // Only fetch data if organizationId is not 2, or for all if that's the default behavior
      if (organizationId !== 2) {
        updateToken();
        fetchData();
      }
    }
  }, [organizationId]); // Re-run effect when organizationId changes

  const fetchData = async () => {
    try {
      setLoader(true);
      let data = null;
      if (user?.userType === "Trainer") {
        data = await fetchTrainerDashboardData();
      } else if (user?.userType === "Admin") {
        data = await fetchAdminDashboardData();
      } else if (user?.userType === "Content manager") {
        data = await fetchContentManagerDashboardData();
      }

      if (data?.success) {
        setDashboardData(data?.result);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const reports = [
    { title: "Courses in LMS", iconClass: "cube-outline", total: dashboardData?.courseCount === null || dashboardData?.courseCount === 0 ? "0" : dashboardData?.courseCount || "--", average: "+11%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Batch Register", iconClass: "buffer", total: dashboardData?.batchCount === null || dashboardData?.batchCount === 0 ? "0" : dashboardData?.batchCount || "--", average: "+29%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Course Referred", iconClass: "tag-text-outline", total: dashboardData?.courseReferCount === null || dashboardData?.courseReferCount === 0 ? "0" : dashboardData?.courseReferCount || "--", average: "0%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Student Registered", iconClass: "briefcase-check", total: dashboardData?.studentCount === null || dashboardData?.studentCount === 0 ? "0" : dashboardData?.studentCount || "--", average: "+89%", badgecolor: "info", navigateLink: "/dashboard" },
  ];
  const trainerReports = [
    { title: "All Courses", iconClass: "cube-outline", total: dashboardData?.courseCount === null || dashboardData?.courseCount === 0 ? "0" : dashboardData?.courseCount || "--", average: "+11%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Your Batches", iconClass: "buffer", total: dashboardData?.batchCount === null || dashboardData?.batchCount === 0 ? "0" : dashboardData?.batchCount || "--", average: "+29%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Your Referred Courses", iconClass: "tag-text-outline", total: dashboardData?.courseReferCount === null || dashboardData?.courseReferCount === 0 ? "0" : dashboardData?.courseReferCount || "--", average: "0%", badgecolor: "info", navigateLink: "/dashboard" },
    { title: "Your Batch Students", iconClass: "briefcase-check", total: dashboardData?.studentCount === null || dashboardData?.studentCount === 0 ? "0" : dashboardData?.studentCount || "--", average: "+89%", badgecolor: "info", navigateLink: "/dashboard" },
  ];

  if (organizationId === 2) {
    return (
      <React.Fragment>
        {loader ? <Loader /> : ""}
        <PowerBIDashboard />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {loader ? <Loader /> : ""}
      {organizationId !== 2 ? <> 
      
      {/* Mini widgets */}
      <Miniwidget reports={reports} trainerReports={trainerReports} user={user} />

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings dashboardData={dashboardData} />
        </Col>

        <Col xl="6">
          {/* Email sent */}
          <EmailSent dashboardData={dashboardData} />
        </Col>

        <Col xl="3">
          <MonthlyEarnings2 dashboardData={dashboardData} />
        </Col>
      </Row>
      </>
      : <></>}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Dashboard);